(() => {
  document.querySelectorAll('[data-plan-finder]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    const shell = root.closest('[data-finder-section]');
    const gate = shell?.querySelector('[data-finder-gate]');
    const wizardWrap = shell?.querySelector('[data-finder-wizard-wrap]');
    const form = root.querySelector('[data-subscription-finder]');
    const steps = [...root.querySelectorAll('[data-step]')];
    const result = root.querySelector('[data-finder-result]');
    const progress = root.querySelector('[data-finder-progress]');
    const bar = root.querySelector('[data-progress-bar]');
    const stepLabel = root.querySelector('[data-step-label]');
    const stepName = root.querySelector('[data-step-name]');
    const labels = ['Su nombre', 'Qué le gusta', 'Cómo juega', 'Qué quieres recibir', 'Su tamaño', 'Su cumpleaños'];

    let current = 0;
    let recommendation = null;
    let quizStarted = false;

    const emitStart = () => {
      if (quizStarted) return;
      quizStarted = true;
      document.dispatchEvent(new CustomEvent('patitas:quiz-start'));
    };

    shell?.querySelectorAll('[data-open-plan-finder]').forEach((button) => {
      button.addEventListener('click', () => {
        emitStart();
        if (gate) gate.hidden = true;
        if (wizardWrap) wizardWrap.hidden = false;
        show(0, false);
      });
    });

    const plans = {
      treat: {
        title: 'Treat Club', price: '$399 MXN', contents: '2 bolsas de premios Patitas', url: '/products/treat-club-premios-mensuales',
        copy: (name) => `Para ${name}, los premios son la prioridad. Esta caja reúne dos bolsas Patitas para paseo, entrenamiento y rutina.`,
        variants: {
          Pequeño: { Tranquilo: '43006329028704', Juguetón: '43006329061472', 'Súper juguetón': '43006329094240' },
          Mediano: { Tranquilo: '43006329127008', Juguetón: '43006329159776', 'Súper juguetón': '43006329192544' },
          Grande: { Tranquilo: '43006329225312', Juguetón: '43006329258080', 'Súper juguetón': '43006329290848' }
        }
      },
      toy: {
        title: 'Toy of the Month', price: '$599 MXN', contents: '2 bolsas de premios + 1 juguete', url: '/products/toy-of-the-month-juguete-mensual',
        copy: (name) => `${name} disfruta los premios y también estrenar algo nuevo. Esta caja equilibra dos bolsas Patitas con un juguete seleccionado.`,
        variants: {
          Pequeño: { Tranquilo: '43006329356384', Juguetón: '43006329389152', 'Súper juguetón': '43006329421920' },
          Mediano: { Tranquilo: '43006329454688', Juguetón: '43006329487456', 'Súper juguetón': '43006329520224' },
          Grande: { Tranquilo: '43006329552992', Juguetón: '43006329585760', 'Súper juguetón': '43006329618528' }
        }
      },
      weekly: {
        title: 'Weekly Play', price: '$999 MXN', contents: '4 juguetes distintos', url: '/products/weekly-play-juguete-cada-semana',
        copy: (name) => `${name} necesita más variedad para no aburrirse. Weekly Play reúne cuatro tipos de juego para rotarlos durante el mes.`,
        variants: {
          Pequeño: { Tranquilo: '43006329716832', Juguetón: '43006329749600', 'Súper juguetón': '43006329782368' },
          Mediano: { Tranquilo: '43006329815136', Juguetón: '43006329847904', 'Súper juguetón': '43006329880672' },
          Grande: { Tranquilo: '43006329913440', Juguetón: '43006329946208', 'Súper juguetón': '43006329978976' }
        }
      }
    };

    const value = (name) => form.querySelector(`input[name="${name}"]:checked`)?.value || '';
    const dog = () => String(form.elements.dog_name?.value || '').trim();
    const updateName = () => root.querySelectorAll('[data-dog-name]').forEach((element) => { element.textContent = dog() || 'tu perro'; });

    const show = (index, focusField = false) => {
      current = Math.max(0, Math.min(index, steps.length - 1));
      steps.forEach((step, position) => { step.hidden = position !== current; });
      form.hidden = false;
      result.hidden = true;
      progress.hidden = false;
      stepLabel.textContent = `Paso ${current + 1} de ${steps.length}`;
      stepName.textContent = labels[current];
      bar.style.width = `${((current + 1) / steps.length) * 100}%`;
      updateName();
      if (focusField) window.setTimeout(() => steps[current].querySelector('input[type="text"], input[type="date"]')?.focus({ preventScroll: true }), 80);
    };

    const valid = () => {
      const error = steps[current].querySelector('[data-error]');
      let ok = true;
      if (current === 0) ok = dog().length > 0;
      if (current === 1) ok = Boolean(value('priority'));
      if (current === 2) ok = Boolean(value('intensity'));
      if (current === 3) ok = Boolean(value('frequency'));
      if (current === 4) ok = Boolean(value('size'));
      if (current === 5) {
        ok = Boolean(value('birthday_choice'));
        if (value('birthday_choice') === 'yes') ok = ok && Boolean(form.elements.birthday.value);
      }
      if (error) error.hidden = ok;
      return ok;
    };

    const choosePlan = () => {
      const scores = { treat: 0, toy: 0, weekly: 0 };
      const priority = value('priority');
      const intensity = value('intensity');
      const frequency = value('frequency');
      if (priority === 'premios') { scores.treat += 4; scores.toy += 1; }
      if (priority === 'equilibrio') { scores.toy += 4; scores.treat += 1; }
      if (priority === 'juego') { scores.weekly += 4; scores.toy += 1; }
      if (intensity === 'Tranquilo') { scores.treat += 2; scores.toy += 1; }
      if (intensity === 'Juguetón') { scores.toy += 2; scores.weekly += 1; }
      if (intensity === 'Súper juguetón') scores.weekly += 3;
      if (frequency === 'premios-mes') scores.treat += 4;
      if (frequency === 'una-sorpresa') scores.toy += 4;
      if (frequency === 'mucha-variedad') scores.weekly += 5;
      const tieBreak = { toy: 3, treat: 2, weekly: 1 };
      return Object.keys(scores).sort((a, b) => scores[b] - scores[a] || tieBreak[b] - tieBreak[a])[0];
    };

    const finish = () => {
      if (!valid()) return;
      emitStart();
      const key = choosePlan();
      const plan = plans[key];
      const name = dog();
      const size = value('size');
      const intensity = value('intensity');
      const birthdayChoice = value('birthday_choice');
      const birthday = form.elements.birthday.value;
      recommendation = { key, plan, name, size, intensity, birthdayChoice, birthday, variantId: plan.variants[size][intensity] };
      root.querySelector('[data-result-dog]').textContent = name;
      root.querySelector('[data-finder-title]').textContent = plan.title;
      root.querySelector('[data-finder-copy]').textContent = plan.copy(name);
      root.querySelector('[data-result-contents]').textContent = plan.contents;
      root.querySelector('[data-result-price]').textContent = plan.price;
      root.querySelector('[data-product-link]').href = `${plan.url}?variant=${recommendation.variantId}`;
      root.querySelector('[data-birthday-result]').innerHTML = birthdayChoice === 'yes'
        ? `<strong>Fecha guardada para el pedido.</strong><br>${birthday}. El registro no garantiza automáticamente un beneficio; la elegibilidad debe confirmarse según la política vigente.`
        : '<strong>Sin fecha de cumpleaños.</strong><br>Puedes compartirla después mediante atención a clientes.';
      form.hidden = true;
      progress.hidden = true;
      result.hidden = false;
      document.dispatchEvent(new CustomEvent('patitas:quiz-complete', { detail: { plan: plan.title, size, intensity } }));
      result.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    const next = () => {
      emitStart();
      if (!valid()) return;
      if (current < steps.length - 1) show(current + 1, true);
      else finish();
    };

    root.querySelectorAll('[data-next]').forEach((button) => button.addEventListener('click', next));
    root.querySelectorAll('[data-back]').forEach((button) => button.addEventListener('click', () => show(current - 1, true)));
    ['priority', 'intensity', 'frequency', 'size'].forEach((name) => form.querySelectorAll(`input[name="${name}"]`).forEach((input) => input.addEventListener('change', () => window.setTimeout(next, 120))));
    form.querySelectorAll('input[name="birthday_choice"]').forEach((input) => input.addEventListener('change', () => {
      const yes = value('birthday_choice') === 'yes';
      root.querySelector('[data-birthday-date]').hidden = !yes;
      if (!yes) form.elements.birthday.value = '';
    }));
    form.elements.dog_name.addEventListener('keydown', (event) => { if (event.key === 'Enter') { event.preventDefault(); next(); } });
    root.querySelector('[data-finish]').addEventListener('click', finish);

    root.querySelector('[data-add-plan]').addEventListener('click', async (event) => {
      if (!recommendation) return;
      const button = event.currentTarget;
      const status = root.querySelector('[data-add-status]');
      button.disabled = true;
      button.textContent = 'Agregando…';
      status.hidden = true;
      const properties = {
        'Nombre del perro': recommendation.name,
        'Tamaño del perro': recommendation.size,
        'Nivel de juego': recommendation.intensity,
        'Qué le gusta más': value('priority'),
        'Preferencia de caja': value('frequency'),
        'Fecha registrada para cumpleaños': recommendation.birthdayChoice === 'yes' ? 'Sí' : 'No'
      };
      if (recommendation.birthday) properties['Fecha de cumpleaños'] = recommendation.birthday;
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(recommendation.variantId), quantity: 1, properties }] }) });
        if (!response.ok) throw new Error('No pudimos agregar la caja.');
        window.location.href = '/cart';
      } catch (error) {
        status.textContent = error.message || 'No pudimos agregar la caja. Intenta otra vez.';
        status.hidden = false;
        button.disabled = false;
        button.textContent = 'Agregar esta caja al carrito';
      }
    });

    root.querySelector('[data-restart]').addEventListener('click', () => {
      form.reset();
      root.querySelector('[data-birthday-date]').hidden = true;
      recommendation = null;
      quizStarted = false;
      show(0, true);
    });

    show(0, false);
  });
})();